// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"638035a9","397":"fd513f0d","453":"86d421e0","555":"7b0d2caa","683":"273e6a06","982":"65b58928"}[chunkId] + ".chunk.js";
};